import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class APIBasePathInterceptor implements HttpInterceptor {
  private apiBase = inject(API_BASE_URL);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith('/')) {
      req = req.clone({ url: this.apiBase + req.url });
    }
    return next.handle(req);
  }
}
